export enum StormDoorEvents {
    EditFormModelDidUpdate = 'StormDoor.Edit.FormModelDidUpdate',
    VariantFormModelDidUpdate = 'StormDoor.Variant.FormModelDidUpdate',
}